import React, { useEffect } from 'react';
import { usePriceAlert } from '../hooks/api/priceAlertApi';
import { priceAlertColumns } from '../enums/columns';
import useAppContext from '../../../hooks/context/useAppContext';
import DataTable from '../../../components/DataTable/DataTable';
import useListHook from '../../../hooks/lists/useListHook';
import { serializeObjectToUrl } from '../../../utils/urlHelper';
import { FormattedMessage } from 'react-intl';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Add from '@material-ui/icons/Add';
import { useHistory } from 'react-router';

const columns = [
  priceAlertColumns.name,
  priceAlertColumns.contract,
  priceAlertColumns.product,
  priceAlertColumns.type,
  priceAlertColumns.warningType,
  priceAlertColumns.minPrice,
  priceAlertColumns.maxPrice,
];

const alertEdit = 'price-alert';
const alertNew = 'price-alert/new';

const PriceAlertList = () => {
  const { getAllPriceAlerts, data, loading, error } = usePriceAlert();
  const { user } = useAppContext();
  const history = useHistory();

  const initialValues = {};

  const { orderByColumn, orderDirection, rows, setOrderByColumn, setOrderDirection, setRows } = useListHook(initialValues);

  useEffect(() => {
    const query = {
      idUser: user.id,
    };
    getAllPriceAlerts(serializeObjectToUrl(query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllPriceAlerts, orderDirection, orderByColumn]);

  useEffect(() => {
    data &&
      setRows(
        data.map((line) => {
          return {
            id: line.id,
            name: line.name,
            contract: line?.contract?.idExternal,
            product: line?.exchangeProduct?.name,
            type: line?.exchangeProduct?.commodity?.name,
            warningType: line.notificationChannels.map((channel) => channel?.name).join(', '),
            minPrice: `${line.minPrice} ${line?.currency?.id}`,
            maxPrice: `${line.maxPrice} ${line?.currency?.id}`,
          };
        }),
      );
  }, [data, setRows]);

  const toolbarComponents = [
    <Tooltip title={<FormattedMessage id={'app.dataTable.toolbarIconTooltip.add'} />} arrow key={1}>
      <IconButton size={'small'} onClick={() => history.push(`/${alertNew}`)}>
        <Add fontSize={'large'} />
      </IconButton>
    </Tooltip>,
  ];

  return (
    <>
      <DataTable
        lineHover
        displayPagination={false}
        displaySearch={false}
        checkboxColumn={false}
        columns={columns}
        data={rows || []}
        loading={loading}
        error={error}
        orderDirection={orderDirection}
        setOrderDirection={setOrderDirection}
        orderByColumn={orderByColumn}
        setOrderByColumn={setOrderByColumn}
        customTools={toolbarComponents}
        onLineClick={(line) => {
          history.push(`/${alertEdit}/${line.id}`);
        }}
      />
    </>
  );
};

PriceAlertList.propTypes = {};

export default PriceAlertList;
